module.exports = __webpack_public_path__ + "static/media/Grey_Button_landing@3x.7af16992.png";